// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profilesection-inline-1 {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f1f5f9;
}

.profilesection-inline-2 {
  font-size: 16px;
  font-weight: 700;
  font-family: 'Plus Jakarta Sans',sans-serif;
}

.profilesection-inline-3 {
  font-size: 12px;
  color: #64748b;
}

.profilesection-inline-4 {
  font-size: 11px;
  color: #94a3b8;
}

.profilesection-inline-5 {
  text-align: center;
  color: #94a3b8;
  padding: 20px;
  font-size: 13px;
}

.profilesection-inline-6 {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/Intern/ProfileSection.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".profilesection-inline-1 {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 16px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.profilesection-inline-2 {\n  font-size: 16px;\n  font-weight: 700;\n  font-family: 'Plus Jakarta Sans',sans-serif;\n}\n\n.profilesection-inline-3 {\n  font-size: 12px;\n  color: #64748b;\n}\n\n.profilesection-inline-4 {\n  font-size: 11px;\n  color: #94a3b8;\n}\n\n.profilesection-inline-5 {\n  text-align: center;\n  color: #94a3b8;\n  padding: 20px;\n  font-size: 13px;\n}\n\n.profilesection-inline-6 {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
